import css from './PlusButton.module.css';

function PlusButton({ onClick }) {
    return (
        <button className={css.button} onClick={onClick}>
            +
        </button>
    );
}

export default PlusButton;
